<template>
  <Header />
  <section id="home">
        <div class="container">
            <div class="image-container">
                <img src="./assets/pic.jpg" alt="Profile">
            </div>
            <div class="text-container">
                <div class="name-designation">
                  <h1>Hi, I'm Louie Izen B. Torres</h1>
                  <p>A fresh Computer Engineer graduate from STI College Muñoz-EDSA</p>
                </div>
                <div class="description">
                  <p>I am a passionate and results-oriented computer engineering graduate with a strong foundation in
                    software development, hardware systems, and emerging technologies. Dedicated to continuous learning
                    and building innovative solutions that make a difference.</p>
                </div>
            </div>
        </div>
    </section>

    <section id="projects">
        <div class="container">
            <h2>Projects</h2>
              <a class="project" href="https://github.com/n1zen/webGenerator" target="_blank">
                <div class="project-content">
                  <h3>Online Barcode Generator Application</h3>
                  <p>A web application that generates barcodes for products. It allows users to input multiple product
                      informations and generate a barcodes that can be used for inventory management and tracking.
                  </p>
                </div>
                <div class="project-tech-stack">
                  <p><span class="tech-stack">Tech Stack:</span> HTML, CSS, JavaScript</p>
                </div>
              </a>
              <a class="project" href="https://github.com/n1zen/ToDoList" target="_blank">
                <div class="project-content">
                  <h3>To Do List Application</h3>
                  <p>A basic task manager applet that allows users to add, edit, delete, and mark tasks as complete.</p>
                </div>
                <div class="project-tech-stack">
                  <p><span class="tech-stack">Tech Stack:</span> HTML, CSS, JavaScript</p>
                </div>
              </a>
	      <a class="project" href="https://github.com/n1zen/ChurchAttendance" target="_blank">
		<div class="project-content">
		    <h3>Fort Andres Bonifacio Church Attendance Application</h3>
		    <p>
			A web based church attendance app for logging and tracking attendees of Fort Andres Bonifactio Adventist Church. Allows attendees to simply log their attendance where admins can monitor their congregation's attendance.
		    </p>
		</div>
		<div class="project-tech-stack">
		    <p><span class="tech-stack">Tech Stack:</span> C#, .NET, Bootstrap</p>
		</div>
	    </a>
        </div>
    </section>

    <section id="skills">
        <div class="container">
            <h2>Technical Skills</h2>
            <div class="skills-container">
              <div class="item">
                <i class="devicon-html5-plain"></i><i class="devicon-css3-plain"></i>
                <p>HTML/CSS</p>
              </div>
              <div class="item">
                <i class="devicon-javascript-plain"></i>
                <p>JavaScript</p>
              </div>
              <div class="item">
                <i class="devicon-typescript-plain"></i>
                <p>TypeScript</p>
              </div>
              <div class="item">
                <i class="devicon-java-plain"></i>
                <p>Java</p>
              </div>
              <div class="item">
                <i class="devicon-python-plain"></i>
                <p>Python</p>
              </div>
              <div class="item">
                <i class="devicon-mysql-plain"></i>
                <p>SQL</p>
              </div>
              <div class="item">
                <i class="devicon-react-plain"></i>
                <p>React/React Native</p>
              </div>
              <div class="item">
                <i class="devicon-npm-original-wordmark"></i>
                <p>Node.js</p>
              </div>
              <div class="item">
                <i class="devicon-bootstrap-plain"></i>
                <p>Bootstrap</p>
              </div>
              <div class="item">
                <i class="devicon-fastapi-plain"></i>
                <p>FastAPI</p>
              </div>
              <div class="item">
                <i class="devicon-git-plain"></i>
                <p>Git</p>
              </div>
              <div class="item">
                <i class="devicon-github-plain"></i>
                <p>GitHub</p>
              </div>
            </div>
        </div>
    </section>

    <section id="achievements">
        <div class="container">
            <h2>Achievements</h2>
            <div class="achievement">
                <h3>Champion - ICpEP NCR Java Programming (2026)</h3>
                <p>
                    The ICpEP NCR Java Programming competition is a programming competition for computer engineering
                    students in the National Capital Region of the Philippines. During the event, I had to solve 5
                    problems in 3 hours with Java. I was able to solve all 5 problems by being a critical-thinker and a
                    problem-solver which helped me to come up with efficient solutions to the problems.
                </p>
            </div>
            <div class="achievement">
                <h3>Best Research - STI College Muñoz-EDSA College Fair and Symposium (2025)</h3>
                <p>
                    The STI College Muñoz-EDSA College Fair and Symposium is a college fair where students from
                    different
                    programs showcase their research and projects. During the event, My groupmates and I presented our
                    research titled
                    "MCU-Based Soil Scanner with Machine Learning Application for Identifying Locations Suitable for
                    Planting Narra Trees" and won the Best Research award. I was the programmer of the group which means
                    I was responsible for the development of the software and hardware of the project.
                </p>
            </div>
        </div>
    </section>

    <section id="education">
        <div class="container">
            <h2>Education</h2>
            <div class="education">
                <h3>Bachelor of Science in Computer Engineering</h3>
                <div class="education-content">
                    <p>STI College Muñoz-EDSA</p>
                    <p>2022 - 2026</p>
                </div>
            </div>
        </div>
    </section>

    <section id="contact">
        <div class="container">
            <h2>Contact Me</h2>
            <div class="contact-content">
                <div class="contact-content-item">
                    <i class="fa-solid fa-envelope"></i>
                    <p>torres070204@gmail.com</p>
                </div>
                <div class="contact-content-item">
                    <i class="fa-solid fa-phone"></i>
                    <p>09762812011</p>
                </div>
                <div class="contact-content-item">
                    <i class="fa-solid fa-location-dot"></i>
                    <p>Caloocan City, Philippines</p>
                </div>
                <a class="contact-content-item" href="https://github.com/n1zen">
                    <i class="fa-brands fa-github"></i>
                    <p>n1zen</p>
                </a>
                <a class="contact-content-item" href="https://www.linkedin.com/in/louie-izen-torres-4557243ab">
                    <i class="fa-brands fa-linkedin"></i>
                    <p>Louie Izen B. Torres</p>
                </a>
            </div>
        </div>
    </section>

    <footer>
        <div class="container">
            <p>&copy; 2026 Louie Izen B. Torres. All rights reserved.</p>
        </div>
    </footer>
</template>

<script>
import Header from './components/Header.vue'

export default {
  components: {
    Header
  },
  name: 'App',
}
</script>
